import { type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../styles.constants';

export const container = (isCollapsed?: boolean): CSSProperties => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  boxSizing: 'border-box',
  padding: isCollapsed === true ? '20px 0 16px' : '24px 8px 20px',
  borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
});

export const avatarWrapper: CSSProperties = {
  position: 'relative',
  display: 'inline-flex',
  marginBottom: 10,
};

export const statusDot: CSSProperties = {
  position: 'absolute',
  bottom: 2,
  right: 2,
  height: 12,
  width: 12,
  borderRadius: '50%',
  background: StyleConstants.LIGHT_GREEN_COLOR,
  border: `2px solid ${StyleConstants.DARK_BLUE_COLOR}`,
  boxSizing: 'border-box',
};

export const avatar: CSSProperties = {
  width: 56,
  height: 56,
  borderRadius: '50%',
  background: 'rgba(255, 255, 255, 0.15)',
  border: '2px solid rgba(255, 255, 255, 0.35)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  fontSize: 19,
  fontWeight: 600,
  color: StyleConstants.WHITE_COLOR,
  letterSpacing: 1,
  userSelect: 'none',
};

export const avatarImage: CSSProperties = {
  width: 56,
  height: 56,
  borderRadius: '50%',
  border: '2px solid rgba(255, 255, 255, 0.35)',
  objectFit: 'cover',
};

export const name: CSSProperties = {
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  fontSize: 15,
  fontWeight: 600,
  color: StyleConstants.WHITE_COLOR,
  textAlign: 'center',
  lineHeight: '18px',
  wordBreak: 'break-word',
  maxWidth: '100%',
};

export const email: CSSProperties = {
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  fontSize: 11,
  fontWeight: 400,
  color: 'rgba(255, 255, 255, 0.7)',
  textAlign: 'center',
  marginTop: 2,
  wordBreak: 'break-all',
  maxWidth: '100%',
};

export const roleBadge: CSSProperties = {
  display: 'inline-block',
  marginTop: 8,
  padding: '3px 10px',
  borderRadius: 12,
  background: 'rgba(255, 255, 255, 0.10)',
  border: '1px solid rgba(255, 255, 255, 0.22)',
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  fontSize: 10,
  fontWeight: 600,
  color: 'rgba(255, 255, 255, 0.85)',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
};
